import "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/core-js/modules/es.array.iterator.js";
import "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/core-js/modules/es.promise.js";
import "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/core-js/modules/es.object.assign.js";
import "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/core-js/modules/es.promise.finally.js";
import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import 'amfe-flexible';
import './vant';
import 'components/law-query.vue';
import '@/static/icons';
import '@/styles/index.less';
import infiniteScroll from 'vue-infinite-scroll';
Vue.use(infiniteScroll); // 全局注册

import { CaptchaConfig, TianAiCaptcha } from './captcha/captcha';
window.TAC = TianAiCaptcha;
window.CaptchaConfig = CaptchaConfig;
Vue.config.productionTip = false;

// 定义数据总线（ai滚动视窗用到）
var eventBus = new Vue();
Vue.prototype.$eventBus = eventBus;

// 非生产环境下面使用vConsole进行调试
if (process.env.VUE_APP_NODE_ENV === 'development') {
  var vconsole = new VConsole();
  console.info("[vconsole] load success, version: ".concat(vconsole.version));
}
// 引入样式
import 'highlight.js/styles/github.css';
import 'highlight.js/styles/github.min.css';
new Vue({
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app');